import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../../axios/index";

// context
import { UserContext } from "../../../Context/UserContextProvider";

import { Link, useHistory } from "react-router-dom";

// styles
import styles from "./UserMyAdsDetail.module.css";
import Dstyles from "../../../Home/UserFilesDetail/UserFilesDetail.module.css";
import loaderStyles from "../../../Dashboard/DashboardFileManagement/DashboardFileManagement.module.css";

// components
import HomeNavbar from "../../../Home/HomeNavbar/HomeNavbar";
import Footer from "../../../Home/Footer/Footer";
import UserSideDashboard from "../../UserSideDashboard/UserSideDashboard";
import CardSlider from "../../../Dashboard/DashboardFileManagement/CardDetail/CardSlider";
import UserFilesDetailFacilities from "../../../Home/UserFilesDetail/UserFilesDetailFacilities/UserFilesDetailFacilities";
import { useLocation } from "react-router-dom";
import ReminderModal from "../../../Dashboard/DashboardFileManagement/CardDetail/ReminderModal/ReminderModal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function UserMyAdsDetail(props) {
  const { userToken } = useContext(UserContext);
  const { state } = useLocation();
  const history = useHistory();
  const [btnLoader, setBtnLoader] = useState(false);
  const [chartData, setChartData] = useState({
    chartData1: null,
    chartData2: null,
  });
  const [reminderData, setReminderData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const [fileData, setFileData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addedFacilitiesID, setAddedFacilitiesID] = useState([]);
  const [facilitiData, setFacilitiData] = useState();
  const [addedFacilities, setAddedFacilities] = useState([]);
  // const [facilities, setFacilities] = useState([])
  const [mapData, setMapData] = useState({
    lat: 0,
    lng: 0,
  });

  useMemo(() => fileData, [fileData]);

  useEffect(() => {
    const getData = async () => {
      // setIsLoading(true)
      const getApiData = await axios.get(`Estate/bySlug/${state.state.slug}`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const getApiDataFacilities = await axios.get(`Specification/GetList`, {
        headers: { authorization: "Bearer " + userToken },
      });

      const detailData = await getApiData.data.data;
      setFileData(detailData);

      const getApiReminderData = await axios.get(`Reminder/1/${state.state.id}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      // console.log(getApiReminderData.data.data)
      setReminderData(getApiReminderData.data.data);

      if (detailData) {
        const status = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 1 : 3;
        const status2 = (await detailData.rentPrice) === null || detailData.rentPrice === 0 ? 2 : 4;
        const [chartData1Promise, chartData2Promise] = await Promise.all([
          axios.get(`Estate/PriceChanges?estateId=${state.state.id}&priceType=${status}`, { headers: { authorization: "Bearer " + userToken } }),
          axios.get(`Estate/PriceChanges?estateId=${state.state.id}&priceType=${status2}`, { headers: { authorization: "Bearer " + userToken } }),
        ]);
        if (chartData1Promise.data.data) setChartData(prevState => ({ ...prevState, chartData1: chartData1Promise.data.data }));
        if (chartData2Promise.data.data) setChartData(prevState => ({ ...prevState, chartData2: chartData2Promise.data.data }));
      }

      if (detailData.address.location) {
        const locationData = detailData.address.location.split(",");
        setMapData(() => {
          return { lat: parseFloat(locationData[0]), lng: parseFloat(locationData[1]) };
        });
      }
      // setFacilities(detailData.facilities.split(","))
      const filteredFacilities = detailData.facilities.split(",") ?? [];
      setAddedFacilities(filteredFacilities);
      setFacilitiData(getApiDataFacilities.data.data);
      const filterdObjects = getApiDataFacilities.data.data.filter(obj => {
        return filteredFacilities.includes(obj.title);
      });
      setAddedFacilitiesID(filterdObjects.map(item => item.id));

      setIsLoading(false);
    };
    getData();
  }, [userToken, state]);

  const data = {
    responsive: true,
    labels: chartData?.chartData2?.map(item => item.pChangeDate),
    datasets: [
      {
        label: fileData?.rentPrice === null || fileData?.rentPrice === 0 ? "تغییرات قیمت کل" : "تغییرات رهن",
        data: chartData?.chartData1?.map(item => item.price),
        borderColor: "#127442",
        backgroundColor: "#127442",
      },
      {
        label: fileData?.rentPrice === null || fileData?.rentPrice === 0 ? "تغییرات هر متر" : "تغییرات اجاره",
        data: chartData?.chartData2?.map(item => item.price),
        borderColor: "rgb(53, 162, 235)",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
    options: {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
          },
        ],
      },
    },
  };

  return (
    <>
      <ReminderModal show={showModal} onHide={() => setShowModal(false)} id={state.state.id} />

      <ToastContainer
        position="top-right"
        autoClose={9000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      {isLoading ? (
        <div className={loaderStyles.loader_container}>
          <div className={loaderStyles.spinner}></div>
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-start vw-100 position-relative" dir="rtl">
          <div className="w-100 ms-0 p-0" style={{ background: "#FFFFFF" }}>
            <HomeNavbar navSale />
            <div className="container py-3 px-0 mt-4">
              <div className="w-100 d-flex justify-content-md-between justify-content-center align-items-start">
                <UserSideDashboard myAds />
                <div className={`d-flex flex-column align-items-center justify-content-start py-4 px-3 ${styles.main_container}`}>
                  <div className="w-100 d-flex flex-wrap justify-content-between align-items-center mb-3">
                    <div className={Dstyles.title}>{e2p(fileData?.title?.toString())}</div>
                    <div className="d-flex align-items-center justify-content-center mt-md-0 mt-2">
                      <div onClick={() => setShowModal(true)} className="d-flex align-items-center justify-content-center ms-4 pointer">
                        {reminderData?.isActive ? (
                          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M3.25422 5.99921e-05L3.24168 0L3.22914 0.00035955L3.09836 0.00410964L3.08653 0.00444862L3.07473 0.00516017C1.44007 0.103688 0.250198 1.52099 0.253915 3.14163C0.25403 3.54755 0.327506 3.88404 0.469614 4.18938C0.60148 4.47272 0.781048 4.69961 0.920665 4.87602L0.923357 4.87942C1.00433 4.98338 1.1058 5.06965 1.22149 5.13285C1.33964 5.1974 1.47001 5.23646 1.60418 5.24752L1.63493 5.25005H1.66579H1.70704H1.71375L1.72046 5.24993C1.85874 5.24746 1.9946 5.21319 2.11751 5.1498C2.21546 5.09929 2.30309 5.03136 2.37624 4.94956L5.20025 2.17574L5.20416 2.1719L5.20801 2.16801C5.30467 2.07025 5.38018 1.95366 5.42985 1.82547C5.47927 1.69793 5.50206 1.56163 5.49682 1.42497C5.49179 1.28887 5.45892 1.15522 5.40021 1.0323C5.34121 0.908754 5.25739 0.798695 5.15397 0.708984L5.15013 0.705676C4.62163 0.253429 3.9498 0.00338799 3.25422 5.99921e-05ZM3.25828 1.50014C3.40186 1.50195 3.54325 1.52523 3.67805 1.56833L1.78419 3.42853C1.76611 3.35669 1.75392 3.265 1.75392 3.14068V3.1397L1.75391 3.13873C1.75156 2.23273 2.39865 1.55455 3.15447 1.50312L3.25828 1.50014ZM13.161 2.12805C11.6536 1.50363 9.99476 1.34025 8.39441 1.65858C6.79407 1.9769 5.32406 2.76264 4.17028 3.91642C3.0165 5.07021 2.23076 6.54022 1.91243 8.14056C1.5941 9.7409 1.75748 11.3997 2.3819 12.9072C2.70171 13.6793 3.1351 14.3939 3.6641 15.0292L1.97358 16.7197C1.68068 17.0126 1.68068 17.4875 1.97358 17.7804C2.26647 18.0733 2.74134 18.0733 3.03424 17.7804L4.72476 16.0899C4.94666 16.2746 5.17881 16.4482 5.42045 16.6097C6.77716 17.5162 8.37221 18.0001 10.0039 18.0001C11.9405 18.0001 13.8069 17.3191 15.2831 16.0899L16.9736 17.7804C17.2665 18.0733 17.7413 18.0733 18.0342 17.7804C18.3271 17.4875 18.3271 17.0126 18.0342 16.7197L16.3437 15.0292C17.573 13.5531 18.2539 11.6867 18.2539 9.75005C18.2539 8.11836 17.7701 6.5233 16.8635 5.1666C15.957 3.80989 14.6685 2.75247 13.161 2.12805ZM8.68705 3.12975C9.99642 2.8693 11.3536 3.00298 12.587 3.51387C13.8204 4.02476 14.8746 4.88992 15.6163 5.99996C16.358 7.10999 16.7539 8.41503 16.7539 9.75005C16.7539 11.5403 16.0428 13.2572 14.7769 14.523C13.511 15.7889 11.7941 16.5001 10.0039 16.5001C8.66889 16.5001 7.36384 16.1042 6.25381 15.3625C5.14378 14.6208 4.27861 13.5666 3.76772 12.3332C3.25683 11.0998 3.12316 9.74257 3.38361 8.4332C3.64406 7.12382 4.28693 5.92109 5.23094 4.97708C6.17494 4.03308 7.37768 3.3902 8.68705 3.12975ZM16.7596 0L16.7721 0.00035955L16.9029 0.00410964L16.9147 0.00444862L16.9266 0.00516017C18.5612 0.103688 19.7511 1.52101 19.7474 3.14166C19.7472 3.54757 19.6738 3.88405 19.5317 4.18938C19.3998 4.47271 19.2202 4.6996 19.0806 4.87602L19.0775 4.88C18.9962 4.98409 18.8943 5.07037 18.7782 5.13345C18.66 5.19762 18.5298 5.23635 18.3958 5.24716L18.3657 5.24958H18.3355H18.2942H18.2875L18.2808 5.24946C18.1425 5.24699 18.0067 5.21273 17.8838 5.14933C17.7858 5.09882 17.6982 5.0309 17.6251 4.94912L14.8011 2.17578L14.7971 2.17193L14.7933 2.16801C14.6966 2.07025 14.6211 1.95366 14.5714 1.82547C14.522 1.69792 14.4992 1.56161 14.5045 1.42494C14.5095 1.28883 14.5424 1.15521 14.6011 1.0323C14.6601 0.908762 14.7439 0.798701 14.8473 0.708984L14.8511 0.705676C15.3796 0.253429 16.0515 0.00338799 16.7471 5.99921e-05L16.7596 0ZM16.3233 1.56831L18.2172 3.42822C18.2352 3.35642 18.2474 3.26482 18.2474 3.14068V3.1397L18.2474 3.13873C18.2497 2.23273 17.6026 1.55455 16.8468 1.50312L16.743 1.50014C16.5994 1.50195 16.4581 1.52522 16.3233 1.56831ZM10.7539 4.50005C10.7539 4.08584 10.4181 3.75005 10.0039 3.75005C9.58969 3.75005 9.25391 4.08584 9.25391 4.50005V9.00005H6.25391C5.83969 9.00005 5.50391 9.33584 5.50391 9.75005C5.50391 10.1643 5.83969 10.5001 6.25391 10.5001H10.0039C10.4181 10.5001 10.7539 10.1643 10.7539 9.75005V4.50005Z"
                              fill="#21409A"
                            />
                          </svg>
                        ) : (
                          <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M3.25373 0.00103655L3.24119 0.000976562L3.22865 0.00133611L3.09787 0.0050862L3.08605 0.00542518L3.07424 0.00613673C1.43958 0.104664 0.24971 1.52197 0.253427 3.14261C0.253542 3.54853 0.327018 3.88502 0.469126 4.19036C0.600991 4.47369 0.78056 4.70058 0.920177 4.877L0.922868 4.8804C1.00384 4.98436 1.10531 5.07062 1.221 5.13383C1.33915 5.19837 1.46952 5.23743 1.60369 5.24849L1.63444 5.25103H1.6653H1.70655H1.71326L1.71997 5.25091C1.85825 5.24843 1.99411 5.21417 2.11703 5.15078C2.21497 5.10027 2.3026 5.03233 2.37575 4.95054L5.19976 2.17672L5.20367 2.17288L5.20752 2.16899C5.30418 2.07123 5.37969 1.95463 5.42936 1.82645C5.47879 1.69891 5.50157 1.56261 5.49633 1.42595C5.4913 1.28984 5.45843 1.1562 5.39973 1.03328C5.34072 0.909731 5.2569 0.799672 5.15348 0.709961L5.14965 0.706653C4.62114 0.254406 3.94931 0.00436455 3.25373 0.00103655ZM3.25779 1.50112C3.40137 1.50293 3.54276 1.5262 3.67756 1.56931L1.7837 3.42951C1.76562 3.35767 1.75343 3.26597 1.75343 3.14165V3.14068L1.75342 3.13971C1.75108 2.23371 2.39816 1.55553 3.15398 1.50409L3.25779 1.50112ZM13.1606 2.12902C11.6531 1.5046 9.99427 1.34122 8.39393 1.65955C6.79358 1.97788 5.32357 2.76362 4.16979 3.9174C3.01601 5.07118 2.23027 6.54119 1.91194 8.14154C1.59361 9.74188 1.75699 11.4007 2.38142 12.9082C2.70122 13.6803 3.13461 14.3949 3.66361 15.0302L1.97309 16.7207C1.68019 17.0136 1.68019 17.4885 1.97309 17.7814C2.26598 18.0742 2.74085 18.0742 3.03375 17.7814L4.72427 16.0908C4.94617 16.2756 5.17832 16.4492 5.41997 16.6107C6.77667 17.5172 8.37173 18.001 10.0034 18.001C11.94 18.001 13.8065 17.3201 15.2826 16.0909L16.9731 17.7814C17.266 18.0742 17.7409 18.0742 18.0338 17.7814C18.3266 17.4885 18.3266 17.0136 18.0338 16.7207L16.3432 15.0302C17.5725 13.5541 18.2534 11.6876 18.2534 9.75103C18.2534 8.11933 17.7696 6.52428 16.863 5.16758C15.9565 3.81087 14.6681 2.75345 13.1606 2.12902ZM8.68656 3.13073C9.99593 2.87028 11.3531 3.00395 12.5865 3.51484C13.8199 4.02574 14.8741 4.8909 15.6158 6.00093C16.3575 7.11096 16.7534 8.41601 16.7534 9.75103C16.7534 11.5412 16.0423 13.2581 14.7764 14.524C13.5105 15.7899 11.7936 16.501 10.0034 16.501C8.6684 16.501 7.36335 16.1051 6.25332 15.3634C5.14329 14.6217 4.27813 13.5675 3.76723 12.3341C3.25634 11.1007 3.12267 9.74354 3.38312 8.43417C3.64357 7.1248 4.28645 5.92206 5.23045 4.97806C6.17446 4.03406 7.37719 3.39118 8.68656 3.13073ZM16.7591 0.000976562L16.7717 0.00133611L16.9024 0.0050862L16.9143 0.00542518L16.9261 0.00613673C18.5607 0.104665 19.7506 1.52198 19.7469 3.14263C19.7468 3.54854 19.6733 3.88503 19.5312 4.19036C19.3993 4.47369 19.2197 4.70058 19.0801 4.87699L19.077 4.88098C18.9957 4.98507 18.8938 5.07135 18.7777 5.13442C18.6595 5.19859 18.5293 5.23733 18.3953 5.24813L18.3652 5.25056H18.335H18.2938H18.287L18.2803 5.25044C18.142 5.24796 18.0062 5.2137 17.8833 5.15031C17.7853 5.0998 17.6977 5.03187 17.6246 4.9501L14.8006 2.17676L14.7967 2.1729L14.7928 2.16899C14.6961 2.07123 14.6206 1.95463 14.5709 1.82645C14.5215 1.6989 14.4987 1.56258 14.504 1.42591C14.509 1.28981 14.5419 1.15618 14.6006 1.03328C14.6596 0.909739 14.7434 0.799678 14.8468 0.709961L14.8507 0.706653C15.3792 0.254405 16.051 0.00436455 16.7466 0.00103655L16.7591 0.000976562ZM16.3228 1.56929L18.2167 3.4292C18.2347 3.3574 18.2469 3.26579 18.2469 3.14165V3.14068L18.2469 3.13971C18.2492 2.23371 17.6021 1.55553 16.8463 1.50409L16.7425 1.50112C16.599 1.50292 16.4576 1.5262 16.3228 1.56929ZM10.7534 4.50103C10.7534 4.08681 10.4176 3.75103 10.0034 3.75103C9.5892 3.75103 9.25342 4.08681 9.25342 4.50103V9.00103H6.25342C5.8392 9.00103 5.50342 9.33681 5.50342 9.75103C5.50342 10.1652 5.8392 10.501 6.25342 10.501H10.0034C10.4176 10.501 10.7534 10.1652 10.7534 9.75103V4.50103Z"
                              fill="#8D8D8D"
                            />
                          </svg>
                        )}
                        <div className={`me-2 ${reminderData?.isActive ? loaderStyles.card_savebtn_active : loaderStyles.card_savebtn}`}>یادآور</div>
                      </div>
                      <p className={`ms-3 ${loaderStyles.card_title_gray_line}`}></p>

                      <div className="d-flex align-items-center justify-content-center ms-md-4">
                        {fileData?.isSavedByUser ? (
                          <svg
                            onClick={removeSaveHandler}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="#21409A"
                            className="bi bi-bookmark-fill pointer"
                            viewBox="0 0 16 16">
                            <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z" />
                          </svg>
                        ) : (
                          <svg
                            onClick={saveCardHandler}
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-bookmark pointer"
                            viewBox="0 0 16 16">
                            <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5V2zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1H4z" />
                          </svg>
                        )}
                        <div className={`me-2 ${loaderStyles.card_savebtn}`}>ذخیره</div>
                      </div>
                    </div>
                  </div>

                  {reminderData?.isActive && (
                    <div className="w-100 d-flex align-items-center justify-content-center my-4 flex-wrap">
                      <div
                        className={`w-75 d-flex align-items-center justify-content-md-between  justify-content-center py-2 px-5 flex-wrap ${loaderStyles.reminder_container}`}>
                        <div className="d-flex align-items-center justify-content-center flex-wrap">
                          <h5 className={`mb-0 ms-3 mt-2 mt-md-0 ${loaderStyles.reminder_title}`}>زمان یادآور:</h5>
                          <div className="my-md-0 my-3 d-flex align-items-center justify-content-center">
                            <div className={loaderStyles.reminder_title}>{reminderData?.reminderDate?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                            <span className={`mx-3 ${loaderStyles.rounded_greeen}`}></span>
                            <div className={loaderStyles.reminder_title}>{reminderData?.reminderTime?.toString().replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d])}</div>
                          </div>
                        </div>
                        <div className={`mb-2 mb-md-0 pointer ${loaderStyles.reminder_title}`} onClick={reminderHandler}>
                          غیرفعال سازی
                        </div>
                      </div>
                    </div>
                  )}

                  <CardSlider images={fileData?.images} wFull p_0 />

                  <UserFilesDetailFacilities
                    data={fileData}
                    mapData={mapData}
                    setMapData={setMapData}
                    w100
                    chartData={data}
                    addedFacilities={addedFacilities}
                    setAddedFacilities={setAddedFacilities}
                    facilitiData={facilitiData}
                    itemID={facilitiData}
                    addedFacilitiesID={addedFacilitiesID}
                    setAddedFacilitiesID={setAddedFacilitiesID}
                  />

                  <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center flex-wrap my-2">
                    {fileData.status === 1 && (
                      <div className={`d-flex align-items-center border-success justify-content-center ms-md-4 ms-0 my-md-0 my-3 ${loaderStyles.border_blue}`}>
                        <svg width="22" height="20" viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg" className="ms-2">
                          <path
                            d="M33.9579 0.594854C15.4513 0.344894 0.34294 15.4533 0.592901 33.9599C0.839698 51.7087 15.2916 66.1606 33.0404 66.4074C51.5501 66.6605 66.6554 51.5521 66.4022 33.0455C66.1586 15.2935 51.7068 0.841651 33.9579 0.594854ZM31.3017 31.0442L39.4571 21.7102C39.8989 21.2046 40.5235 20.8953 41.1934 20.8502C41.8633 20.8051 42.5237 21.0279 43.0293 21.4698C43.5349 21.9116 43.8443 22.5361 43.8894 23.2061C43.9345 23.876 43.7116 24.5364 43.2698 25.042L35.1144 34.376C34.8956 34.6263 34.6297 34.8311 34.3318 34.9787C34.0339 35.1263 33.7098 35.2137 33.3781 35.236C33.0464 35.2584 32.7135 35.2151 32.3985 35.1088C32.0835 35.0025 31.7925 34.8352 31.5422 34.6164C31.2918 34.3977 31.087 34.1317 30.9395 33.8338C30.7919 33.5359 30.7044 33.2118 30.6821 32.8801C30.6598 32.5484 30.703 32.2156 30.8093 31.9005C30.9156 31.5855 31.0829 31.2946 31.3017 31.0442ZM25.1539 45.417C24.6793 45.8913 24.0357 46.1578 23.3647 46.1578C22.6936 46.1578 22.05 45.8913 21.5754 45.417L13.9895 37.8232C13.7546 37.588 13.5682 37.3089 13.4411 37.0017C13.3141 36.6945 13.2487 36.3653 13.2489 36.0328C13.249 35.7004 13.3146 35.3712 13.442 35.0641C13.5694 34.757 13.7559 34.4781 13.9911 34.2431C14.2263 34.0081 14.5055 33.8218 14.8127 33.6947C15.1199 33.5676 15.4491 33.5023 15.7815 33.5024C16.114 33.5025 16.4431 33.5682 16.7502 33.6955C17.0573 33.8229 17.3363 34.0095 17.5713 34.2447L25.165 41.8384C25.6379 42.3145 25.9024 42.9589 25.9003 43.63C25.8982 44.301 25.6298 44.9438 25.1539 45.417ZM53.1243 25.042L35.4245 45.292C35.1964 45.5533 34.9171 45.7649 34.6039 45.9138C34.2907 46.0626 33.9502 46.1455 33.6036 46.1574H33.5181C33.1855 46.1574 32.8562 46.0919 32.5489 45.9646C32.2416 45.8373 31.9624 45.6507 31.7273 45.4154L24.143 37.8216C23.6685 37.3467 23.402 36.7026 23.4023 36.0312C23.4026 35.3598 23.6696 34.716 24.1446 34.2415C24.6196 33.7669 25.2636 33.5005 25.935 33.5008C26.6064 33.5011 27.2502 33.7681 27.7247 34.2431L32.4392 38.9623C32.5618 39.0849 32.7082 39.181 32.8694 39.2446C33.0306 39.3083 33.2032 39.3382 33.3765 39.3324C33.5497 39.3266 33.72 39.2853 33.8766 39.211C34.0332 39.1367 34.1729 39.0311 34.287 38.9006L49.3163 21.7102C49.7581 21.2046 50.3827 20.8953 51.0526 20.8502C51.7225 20.8051 52.3829 21.0279 52.8885 21.4698C53.3941 21.9116 53.7035 22.5361 53.7486 23.2061C53.7937 23.876 53.5708 24.5364 53.129 25.042H53.1243Z"
                            fill="#449114"
                          />
                        </svg>

                        {btnLoader ? (
                          <div className={loaderStyles.btn_loader_container}>
                            <div className={loaderStyles.btn_spinner}></div>
                          </div>
                        ) : (
                          <div className={`text-success pointer ${loaderStyles.text_white}`} onClick={activeHandler} style={{ zIndex: "10" }}>
                            انتشار
                          </div>
                        )}
                      </div>
                    )}
                    {state.isMine ? (
                      <div className="d-flex align-items-center justify-content-center my-md-0 my-2">
                        <Link
                          to={{
                            pathname: `/user-edit-file/${fileData.slug}`,
                            state: {
                              state: fileData,
                              userAdd: true,
                            },
                          }}
                          className={`d-flex align-items-center justify-content-center ${styles.edit_btn}`}
                          type="">
                          <svg className="ms-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M2.875 4.74977C2.57663 4.74977 2.29048 4.8683 2.0795 5.07928C1.86853 5.29025 1.75 5.5764 1.75 5.87477V17.1248C1.75 17.4231 1.86853 17.7093 2.0795 17.9203C2.29048 18.1312 2.57663 18.2498 2.875 18.2498H14.125C14.2727 18.2498 14.419 18.2207 14.5555 18.1641C14.692 18.1076 14.816 18.0247 14.9205 17.9203C15.025 17.8158 15.1078 17.6918 15.1644 17.5553C15.2209 17.4188 15.25 17.2725 15.25 17.1248V8.49977C15.25 8.08556 15.5858 7.74977 16 7.74977C16.4142 7.74977 16.75 8.08556 16.75 8.49977V17.1248C16.75 17.4695 16.6821 17.8108 16.5502 18.1293C16.4183 18.4478 16.2249 18.7372 15.9812 18.9809C15.7374 19.2247 15.448 19.418 15.1295 19.55C14.8111 19.6819 14.4697 19.7498 14.125 19.7498H2.875C2.17881 19.7498 1.51113 19.4732 1.01884 18.9809C0.526562 18.4886 0.25 17.821 0.25 17.1248V5.87477C0.25 5.17858 0.526562 4.5109 1.01884 4.01861C1.51113 3.52633 2.17881 3.24977 2.875 3.24977H10.7256C11.1398 3.24977 11.4756 3.58556 11.4756 3.99977C11.4756 4.41398 11.1398 4.74977 10.7256 4.74977H2.875Z"
                              fill="#21409A"
                            />
                            <path
                              d="M19.5597 0.495863C19.4912 0.420601 19.4081 0.360008 19.3156 0.317746C19.223 0.275483 19.1228 0.252428 19.0211 0.249975C18.9193 0.247521 18.8182 0.26572 18.7237 0.30347C18.6292 0.341221 18.5433 0.397741 18.4713 0.469613L17.8914 1.04664C17.8211 1.11696 17.7817 1.21231 17.7817 1.31172C17.7817 1.41114 17.8211 1.50648 17.8914 1.5768L18.423 2.10743C18.4578 2.14243 18.4992 2.17021 18.5448 2.18917C18.5905 2.20812 18.6394 2.21788 18.6887 2.21788C18.7381 2.21788 18.787 2.20812 18.8327 2.18917C18.8783 2.17021 18.9197 2.14243 18.9545 2.10743L19.5198 1.54493C19.8058 1.25946 19.8325 0.794457 19.5597 0.495863Z"
                              fill="#21409A"
                            />
                            <path
                              d="M16.7191 2.21852L8.25719 10.6654C8.20588 10.7165 8.16859 10.7799 8.14891 10.8496L7.7575 12.0154C7.74812 12.047 7.74746 12.0806 7.75558 12.1126C7.7637 12.1446 7.78029 12.1738 7.80362 12.1971C7.82695 12.2204 7.85615 12.237 7.88813 12.2451C7.9201 12.2532 7.95368 12.2526 7.98531 12.2432L9.15016 11.8518C9.21984 11.8321 9.28328 11.7948 9.33438 11.7435L17.7812 3.28071C17.8594 3.20172 17.9032 3.0951 17.9032 2.98399C17.9032 2.87288 17.8594 2.76625 17.7812 2.68727L17.3148 2.21852C17.2358 2.13966 17.1286 2.09537 17.017 2.09537C16.9053 2.09537 16.7981 2.13966 16.7191 2.21852Z"
                              fill="#21409A"
                            />
                          </svg>
                          ویرایش
                        </Link>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      )}
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setBtnLoader(false);
    }
  }

  async function activeHandler() {
    try {
      notify("درحال تایید فایل برای انتشار", "success");
      setBtnLoader(true);
      var saveData = {
        estateId: fileData.id,
      };

      const addSave = await axios.post(`Estate/ReleaseEstate`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      notify("فایل با موفقیت تایید شد", "success");
      setBtnLoader(false);
      history.push("/user-files");
      window.location.reload(false);
    } catch (error) {
      notify("خطایی رخ داد", "error");
      // console.log(error)
    }
  }

  async function reminderHandler() {
    try {
      notify("درحال حذف تنظیم یادآور", "success");
      var data = {
        reminderId: reminderData?.id,
      };

      const postApiData = await axios.delete("Reminder/DeleteReminder", {
        data: data,
        headers: {
          authorization: "Bearer " + userToken,
        },
      });
      // console.log(postApiData)
      notify("یادآور حذف شد", "success");
      window.location.reload(false);
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function saveCardHandler() {
    notify("درحال ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const addSave = await axios.post(`Estate/SaveEstate?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      if (addSave.data.isSuccess === true) {
        // setSaveCard(true)
        window.location.reload(false);
      }
    } catch (error) {
      notify("خطای سرور", "error");
    }
  }

  async function removeSaveHandler() {
    notify("درحال حذف ذخیره فایل", "success");
    try {
      var saveData = new FormData();
      saveData.append("estateId", state.state.id);

      const removeSave = await axios.post(`Estate/RemoveFromSaveList?estateId=${state.state.id}`, saveData, {
        headers: { authorization: "Bearer " + userToken },
      });
      if (state.isMine) {
        if (removeSave.data.isSuccess === true) {
          // setSaveCard(false)

          window.location.reload(false);
        }
      } else {
        history.replace("/user-saved-files");
      }
    } catch (error) {
      // console.log(error)
      notify("خطای سرور", "error");
    }
  }
}
